import type { OptionDB } from "@project/emerge";
import { LTCaseUserOption } from "../enum/LTCaseUserOption";
import { VariableOptionType } from "../enum/VariableOptionType";
import type { RunnerInfos } from "../interfaces/RunnerInfos";
import type { RunnerType } from "../interfaces/RunnerType";
import { createVariableOption } from "./createVariableOption";

export const createRunners = (
  optionDb: OptionDB,
  _strength = 18,
  count: 2 | 3 = 2,
  partSelection: RunnerType = optionDb.getByName(
    LTCaseUserOption.RunnerType,
    "1004",
  ),
): RunnerInfos => {
  return createVariableOption<RunnerInfos>(VariableOptionType.RUNNERS, {
    count,
    fullLength: true,
    partSelection,
  });
};
